import React from 'react';
import {
  addPathToList, Asset_requirements_paragraph,
  Change_paying_account,
  File_type,
  getSubCategoryId,
  select_a_Bills,
  Your_customer_can_click_account_balance,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import AssetRequirements from '../components/PanelsComponents/General/AssetRequirements';

//= ========================================================================
const Panel_D01_PayBillsPayingAccount = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'how_much_to_transfer',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });
  const service = globJSON.configurations.services[subCategoryId];

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={select_a_Bills}
      panelSubHeadline={Change_paying_account}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/select_bill/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/select_bill/`)}
      tooltipsTitles={service.screens_ordering}
      paragraph={Your_customer_can_click_account_balance}
      language={language}
    >
      <AssetRequirements paragraph={Asset_requirements_paragraph} details={File_type} />
    </FullPagePanel>
  );
};

export default Panel_D01_PayBillsPayingAccount;
